// Bul deletion means: that we could delete multiple elements per 1 request.
export const BULK_ALLOWED = new Set([
  "Path",
  "PracticeGreen",
  "PracticeBunker",
  "Residence",
  "Condo",
  "Hotel",
  "Business",
  "Pool",
  "ParkingLot",
  "Street",
  "Fence",
  "Patio",
]);

export const normalizeFacilityForApi = (name) => {
  switch (name) {
    case "Path": return "Path";
    case "PracticeGreen": return "PracticeGreen";
    case "PracticeBunker": return "PracticeBunker";
    default: return name;
  }
};

export const supportsBulk = (el) => BULK_ALLOWED.has(el);
